import React from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO =
  "https://customer-assets.emergentagent.com/job_cbd3e065-04c9-49ae-9568-054bf18e1f81/artifacts/nukkl7c1_1000648567.png";

const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Philosophy", href: "#what-we-do" },
  { label: "Founder", href: "#founder" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  const hrefFor = (anchor) => (onHome ? anchor : `/${anchor}`);

  return (
    <header
      className="nav-glass sticky top-0 z-50"
      data-testid="site-navbar"
    >
      <div className="container-kw flex items-center justify-between py-4">
        <Link
          to="/"
          className="flex items-center gap-3"
          data-testid="nav-logo-link"
        >
          <img
            src={LOGO}
            alt="King's Wake Digital"
            className="h-9 w-9 rounded-md object-cover"
          />
          <div className="leading-tight">
            <div className="font-display font-bold text-[15px] text-[color:var(--kw-black)]">
              King&apos;s Wake
            </div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-[color:var(--kw-muted)]">
              Digital Pvt. Ltd.
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={hrefFor(l.href)}
              className="text-sm font-medium text-[color:var(--kw-black)] hover:text-[color:var(--kw-muted)] transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={hrefFor("#contact")}
          className="btn-pill btn-primary text-sm px-5 py-2.5"
          data-testid="nav-contact-cta"
        >
          Contact
        </a>
      </div>
    </header>
  );
}
